import { Typography } from 'antd';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

const DeleteThirdPartyJobModal = ({ open, onClose, onConfirm }: Props) => {
    return (
        <ConfirmationModal
            open={open}
            width={580}
            type="default"
            title="Remove 3rd-party job?"
            confirmButtonText="Remove Job"
            onConfirm={onConfirm}
            onCancel={onClose}
            content={<Typography.Text>This 3rd-party job will be removed from the manifest.</Typography.Text>}
        />
    );
};

export default DeleteThirdPartyJobModal;
